import { createFileRoute } from '@tanstack/react-router';
import { HelpPage } from '@/features/help/help-page';

/** `/help/$topic`: contextual help from a tool (for example `/help/five-s`), opened at its section. */
export const Route = createFileRoute('/_app/_platform/help/$topic')({
    staticData: { crumbs: [{ label: 'shell.help', to: '/help' }, { label: 'shell.help' }] },
    component: function HelpTopicRoute() {
        const { topic } = Route.useParams();
        return <HelpPage topic={topic} />;
    },
});
